/**************************************************
 * Nombre:       Formulario_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {FlagOutlined, GeneratingTokensOutlined, MoneyOutlined, WalletOutlined} from "@mui/icons-material";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {useState} from "react";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {TIPOSRETIRO} from "../../Constantes";


const Formulario_Retiro_Bonos = ({...props}) => {
    const [seleccion, setSeleccion] = useState({});
    const [destino, setDestino] = useState({});


    const cambia = (nom) => {

        let index = TIPOSRETIRO.findIndex((e) => e.nombre === nom);
        if (index > -1) {
            setSeleccion(TIPOSRETIRO[index])
            props.props.setValue('corta', TIPOSRETIRO[index].corta);
        }


    }

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor del Retiro en USD'} dato={'valor'} {...props}

                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectFuncion Icono={WalletOutlined} nombre={'Destino del retiro'}
                                          dato={'destino'} {...props}
                                          setDato={setDestino} opciones={['Wallet de Deposito', 'Wallet Externa']}

                    />
                </Grid>

                {destino === 'Wallet Externa' &&

                    <>

                        <Grid container size={6}>
                            <IngresoTexto Icono={GeneratingTokensOutlined} nombre={'Tipo de Crypto'}
                                          dato={'tipo'} {...props} editable={false}/>
                        </Grid>

                        <Grid container size={12}>
                            <IngresoTexto lineas={3} nombre={'Dirección de Billera (Wallet)'}
                                          dato={'billetera'} {...props}
                                          requerido={'La direccion de Billera es obligatoria'}/>
                        </Grid>

                        <Grid container size={6}>
                            <IngresoSelectFuncion Icono={FlagOutlined} nombre={'Tipo de retiro'}
                                                  dato={'metodo'} {...props}
                                                  requerido={'el tipo de retiro es obligatorio'}
                                                  opciones={TIPOSRETIRO.map((it) => it.nombre)}
                                                  setDato={cambia}
                            />
                        </Grid>

                        <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 14, lineHeight: 1.1}}>
                                {seleccion.nombre &&
                                    seleccion.descripcion
                                }
                            </Typography>
                        </Grid>

                    </>


                }

                {destino === 'Wallet de Deposito' &&


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1}}>
                        <Typography sx={{fontSize: 14, lineHeight: 1.2}}>Se descontará un Fee de 5% por la
                            trasnferencia, ésta será inmediata</Typography>
                    </Grid>


                }

            </Grid>

        </form>

    )

}
export default Formulario_Retiro_Bonos

